// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__mKbw6","rootSuccess":"CompleteLink_rootSuccess__7wahl","rootFailure":"CompleteLink_rootFailure__3umGB","isDisabled":"CompleteLink_isDisabled__1Pxij"};